<template>
  <div class="weeknav">
    <button @click="prevWeek">‹ 上一周</button>
    <div class="weekrange">{{ rangeLabel }}</div>
    <button @click="nextWeek">下一周 ›</button>
    <div class="date-jump">
      <button @click="openDatePicker">选择日期</button>
      <el-date-picker
        ref="datePicker"
        v-model="jumpDate"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        :clearable="false"
        class="jump-date-picker"
        @change="onDateChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeekNavigator',
  props: {
    weekStart: {
      type: Date,
      required: true
    }
  },
  data() {
    return {
      jumpDate: ''
    }
  },
  computed: {
    rangeLabel() {
      const start = new Date(this.weekStart)
      const end = new Date(this.weekStart)
      end.setDate(end.getDate() + 6)
      const fmt = d => `${d.getMonth() + 1}月${d.getDate()}日`
      return `${fmt(start)} - ${fmt(end)}`
    }
  },
  methods: {
    prevWeek() {
      this.$emit('change-week', -7)
    },
    nextWeek() {
      this.$emit('change-week', 7)
    },
    openDatePicker() {
      this.$refs.datePicker.focus()
    },
    onDateChange(dateStr) {
      this.$emit('jump-to-date', dateStr)
      this.jumpDate = ''
    }
  }
}
</script>

<style scoped>
.weeknav{
  display:flex;
  align-items:center;
  gap:0.625rem;
  font-size:0.875rem;
}
/* 轻量扁平：白底 + 2px 描边 + 8px 圆角，hover 只做浅绿底，不再整块反色 */
.weeknav button{
  border:2px solid var(--lp-border,#e3efe6);
  background:var(--lp-surface,#fff);
  color:var(--lp-text,#26332b);
  padding:0.313rem 0.75rem;
  cursor:pointer;
  font-size:0.813rem;
  border-radius:0.5rem;
  transition:.15s;
  font-family:inherit;
}
.weeknav button:hover{
  background:var(--lp-primary-soft,#e9f5ec);
  border-color:var(--lp-primary-soft2,#d5ebdb);
  color:var(--lp-primary-dark,#2f7a4a);
}
.weekrange{
  font-weight:600;
  min-width:150px;
  text-align:center;
  color:var(--lp-text,#26332b);
}
.date-jump{
  position:relative;
  display:inline-block;
}
.jump-date-picker{
  position:absolute;
  top:0;
  left:0;
  width:0;
  height:0;
  overflow:hidden;
  opacity:0;
}

@media (max-width:700px){
  .weekrange{min-width:auto;}
  .weeknav button{padding:0.313rem 0.5rem;font-size:0.75rem;}
}
</style>
